import moment from 'moment'

const prepareShow = rent => {
  rent.date_go_in = moment(rent.date_go_in, 'YYYYMMDD').format('DD/MM/YYYY')
  rent.date_go_out = moment(rent.date_go_out, 'YYYYMMDD').format('DD/MM/YYYY')

  return rent
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/index/resources/methods.js